/**
 * VANGUARD SOFTWARE STUDIO — BILINGUAL I18N SYSTEM (ES / EN)
 * Complete localized dictionary, automated browser detection,
 * persistent user preference (localStorage + query param),
 * and dynamic SEO metadata updater.
 */

export const translations = {
  es: {
    // Meta / SEO (High-CTR Commercial Positioning)
    'meta.title': 'Vanguard — Desarrollo de Software a Medida y Sistemas para Empresas',
    'meta.desc': 'Construimos la infraestructura digital que escala tu negocio y automatiza tus operaciones. Prototipo funcional en Semana 2 y código 100% tuyo. Cotiza hoy.',
    'meta.og_title': 'Vanguard — Desarrollo de Software a Medida y Automatización de Procesos',
    'meta.og_desc': 'Construimos plataformas digitales de alta ingeniería y automatizamos operaciones para empresas. Prototipo funcional en Semana 2. Código 100% tuyo.',

    // Navigation (Desktop & Mobile)
    'nav.system': 'Sistema',
    'nav.results': 'Resultados',
    'nav.governance': 'Gobernanza',
    'nav.contact': 'Contacto',
    'nav.open_menu': 'Abrir menú de navegación',
    'nav.close_menu': 'Cerrar menú',
    'nav.eyebrow': 'Navegación',
    'nav.home': 'Inicio',
    'nav.digital_system': 'Sistema Digital',
    'nav.start_project': 'Iniciar Proyecto',
    'nav.status_available': 'Disponible para nuevos proyectos',
    'nav.wa_direct': 'WhatsApp Directo',

    // Hero Section
    'hero.eyebrow': 'Software & Webs a Medida para Empresas en Crecimiento',
    'hero.title': 'Software y webs diseñadas desde cero para tu modelo de negocio.',
    'hero.desc': 'No adaptamos herramientas genéricas a tu empresa. Construimos el sistema que tu operación necesita, exactamente como tú trabajas. Prototipo funcional en la segunda semana, 100% de tu propiedad.',
    'hero.cta': 'Cuéntame qué no está funcionando',
    'hero.microcopy': 'Habla con nuestro ingeniero.',
    'hero.carousel_prev': 'Proyecto anterior',
    'hero.carousel_next': 'Siguiente proyecto',

    // Perspective Carousel Cards
    'card1.tag': 'SaaS Core',
    'card1.name': 'Gestión Operativa',
    'card1.desc': 'Control centralizado',
    'card1.alt': 'Core SaaS Architecture — Dashboard y Analítica',

    'card2.tag': 'Fintech',
    'card2.name': 'Banca & Finanzas',
    'card2.desc': 'Pagos en tiempo real',
    'card2.alt': 'Ecosistema Financiero Móvil',

    'card3.tag': 'Logística',
    'card3.name': 'Portal Logístico',
    'card3.desc': 'Trazabilidad de flota',
    'card3.alt': 'Portal Logístico en Tablet',

    'card4.tag': 'Hospitality',
    'card4.name': 'Smart Gastronomía',
    'card4.desc': 'Comandas y reservas',
    'card4.alt': 'Smart Hospitality & Food Tech',

    'card5.tag': 'HealthTech',
    'card5.name': 'Portal Clínico',
    'card5.desc': 'Historiales digitales',
    'card5.alt': 'Sistema Médico en Tablet',

    'card6.tag': 'Medicina',
    'card6.name': 'Agendamiento Dental',
    'card6.desc': 'Citas automatizadas',
    'card6.alt': 'App Dental Móvil',

    'card7.tag': 'Enterprise',
    'card7.name': 'Suite ERP',
    'card7.desc': 'Finanzas y operaciones',
    'card7.alt': 'Portal Empresarial',

    'card8.tag': 'Automatización',
    'card8.name': 'Flujos de Datos',
    'card8.desc': 'Sincronización 24/7',
    'card8.alt': 'Plataforma Operativa',

    // Section 2: Sistema Digital Integral
    'sec2.eyebrow': 'El Problema que Frenaba a Tus Competidores',
    'sec2.title': 'Un sistema hecho para tu empresa elimina los cuellos de botella que el software genérico nunca resolverá.',
    'sec2.desc': 'El software genérico no fue diseñado para tu negocio — fue diseñado para todos los negocios a la vez. Por eso tu equipo termina adaptándose a él, en lugar de al revés. Vanguard construye la plataforma exacta que tu operación necesita: tu frente comercial y tu gestión interna en un solo sistema propio.',

    'sec2.card1_title': 'Operación Unificada',
    'sec2.card1_desc': 'Centraliza ventas, logística y atención al cliente en una sola base operativa, eliminando datos duplicados y demoras de comunicación entre áreas.',

    'sec2.card2_title': 'Atención 24/7',
    'sec2.card2_desc': 'Tu negocio sigue vendiendo y captando clientes mientras duermes. El portal califica prospectos y dispara acciones internas en automático.',

    'sec2.card3_title': 'Automatización de Procesos',
    'sec2.card3_desc': 'Elimina la carga operativa innecesaria desde el primer día. Cada proceso que hoy hace una persona se convierte en un flujo que el sistema ejecuta solo.',

    'sec2.wf1_title': 'Portal comercial de alta conversión',
    'sec2.wf1_sub': 'Capta, califica y cierra clientes sin intervención de tu equipo',
    'sec2.wf2_title': 'Backoffice operativo sincronizado',
    'sec2.wf2_sub': 'Despacha, factura y gestiona pedidos sin hojas de cálculo',
    'sec2.wf3_title': 'Reportes ejecutivos en tiempo real',
    'sec2.wf3_sub': 'Toma decisiones con datos, no con suposiciones',
    'sec2.wf4_title': 'Código 100% tuyo, sin rentas',
    'sec2.wf4_sub': 'Propiedad total del software desde el primer día',

    'sec2.mockup_status': 'Ecosistema Vanguard · Activo',
    'sec2.mockup_portal': 'Portal Comercial',
    'sec2.mockup_live': 'En vivo',
    'sec2.mockup_backoffice': 'Backoffice',
    'sec2.mockup_synced': 'Sincronizado',
    'sec2.flow_step1': 'Prospecto entra',
    'sec2.flow_step2': 'Sistema califica',
    'sec2.flow_step3': 'Equipo actúa',
    'sec2.flow_step4': 'Venta cerrada',

    // Section 3: Automatización
    'sec3.eyebrow': 'Automatización Inteligente',
    'sec3.title': 'Deja de perder dinero en tareas repetitivas: automatización inteligente para todo tu equipo.',
    'sec3.desc': 'Cada hora que tu equipo dedica a copiar datos, perseguir aprobaciones o actualizar hojas de cálculo es dinero que se va sin generar valor. Eso termina aquí.',

    'sec3.before_badge': 'Antes',
    'sec3.before_title': 'Caos Manual',
    'sec3.ba1_bad': 'Cotizaciones enviadas por correo, respuesta en días',
    'sec3.ba2_bad': 'Datos de clientes en 3 hojas de cálculo distintas',
    'sec3.ba3_bad': 'Facturas generadas a mano, errores frecuentes',
    'sec3.ba4_bad': 'Tu director apagando incendios operativos todo el día',
    'sec3.ba5_bad': 'Reportes de ventas preparados manualmente cada semana',

    'sec3.after_badge': 'Ahora',
    'sec3.after_title': '1 Clic. Automatizado.',
    'sec3.ba1_good': 'Portal califica y responde prospectos en segundos, 24/7',
    'sec3.ba2_good': 'Toda la información del cliente en un solo panel unificado',
    'sec3.ba3_good': 'Facturas generadas y enviadas en automático al cerrar venta',
    'sec3.ba4_good': 'Tu director dedicado a estrategia, no a tareas repetitivas',
    'sec3.ba5_good': 'Dashboard ejecutivo actualizado en tiempo real, siempre listo',

    'sec3.pillar1_title': 'Cero Interrupción Operativa',
    'sec3.pillar1_desc': 'Moderniza los flujos de trabajo sin pausar la operación. Tu equipo sigue trabajando mientras el sistema se activa en paralelo.',
    'sec3.pillar2_title': 'Precisión y Cero Errores',
    'sec3.pillar2_desc': 'Reduce errores humanos y acelera la entrega de tus productos o servicios. Menos revisiones. Más entregas a tiempo.',
    'sec3.pillar3_title': 'Enfoque Estratégico Real',
    'sec3.pillar3_desc': 'Libera a tus líderes para que se dediquen a la estrategia, no a apagar incendios. El sistema los respalda en silencio.',

    'sec3.mid_badge': 'Ahorro Inmediato',
    'sec3.mid_title': '¿Tu equipo pierde más de 5 horas a la semana en tareas repetitivas?',
    'sec3.mid_desc': 'Hagamos un diagnóstico técnico de 15 minutos. Te mostramos con exactitud qué procesos automatizar primero para recuperar inversión desde el primer mes.',
    'sec3.mid_cta_btn': 'Solicitar diagnóstico gratuito',
    'sec3.mid_wa_btn': 'Preguntar por WhatsApp',
    'sec3.mid_wa_msg': 'Hola equipo Vanguard, quisiera consultar sobre la automatización de procesos para mi empresa.',

    // Section 4: Motor de Ventas
    'sec4.eyebrow': 'Motor de Ventas',
    'sec4.title': 'Convierte visitas en ventas y construye una confianza inquebrantable con tus clientes.',
    'sec4.desc': 'Un negocio que responde en segundos cierra más que uno que responde en días. Tu portal comercial trabaja como tu mejor vendedor, disponible en todo momento, sin vacaciones y sin errores.',

    'sec4.funnel_header': 'Embudo de Conversión · En Vivo',
    'sec4.funnel_step1': 'Visitas al portal',
    'sec4.funnel_step2': 'Interacción cualificada',
    'sec4.funnel_step3': 'Solicitudes recibidas',
    'sec4.funnel_step4': 'Propuestas aceptadas',
    'sec4.funnel_step5': 'Ventas cerradas',
    'sec4.funnel_rate': 'Tasa de conversión: <strong>22.0%</strong>',
    'sec4.funnel_vs': 'vs. industria: 3–5%',

    'sec4.benefit1_title': 'El Valor de la Agilidad',
    'sec4.benefit1_desc': 'Responde más rápido, cierra acuerdos en menos tiempo y mejora la experiencia del cliente. Cada minuto de demora es una oportunidad que se pierde.',
    'sec4.benefit2_title': 'Conoce a tu Cliente',
    'sec4.benefit2_desc': 'Transforma datos en decisiones inteligentes para vender más a quienes ya te conocen. Tu sistema aprende el comportamiento de cada prospecto.',
    'sec4.benefit3_title': 'Crecimiento Continuo',
    'sec4.benefit3_desc': 'Aumenta tu facturación mediante un embudo digital optimizado que procesa picos de demanda sin perder pedidos ni ralentizar la experiencia de compra.',

    // Section 5: Infraestructura y Seguridad
    'sec5.eyebrow': 'Garantía y Propiedad',
    'sec5.title': 'Software que suma a tu patrimonio, no a tus gastos fijos.',
    'sec5.desc': 'Diseñado a tu medida para operar sin interrupciones, con la tranquilidad de probar antes de decidir y acompañamiento técnico continuo para cuando lo necesites.',

    'sec5.block1_title': 'Tu empresa es la única dueña',
    'sec5.block1_desc': 'Entregamos todo: código, accesos y base de datos. La tecnología es tuya, y si lo deseas, gestionamos el soporte técnico y te acompañamos en cada etapa de crecimiento.',
    'sec5.block1_tag': 'Libertad y Respaldo',

    'sec5.block2_title': 'No colapsa bajo presión',
    'sec5.block2_desc': 'Soporta el volumen que tienes hoy y el que tendrás cuando multipliques tus ventas, manteniendo siempre tu operación rápida y estable.',
    'sec5.block2_tag': 'Escalable',

    'sec5.block3_title': 'Prototipo navegable en Semana 2',
    'sec5.block3_desc': 'Tocas y pruebas el sistema antes del pago final. Si no te gusta el resultado o no responde a tu necesidad, no continúas.',
    'sec5.block3_tag': 'Semana 2',

    'sec5.guarantee_title': 'Primero lo pruebas, luego decides',
    'sec5.guarantee_desc': 'Un prototipo navegable con tu flujo real en 14 días. Cero riesgo para tu negocio y acompañamiento de nuestro equipo desde el primer momento.',
    'sec5.pricing_callout': 'Compara esto con agencias tradicionales que cobran meses por adelantado por sitios estáticos que no captan ni cierran clientes. Con Vanguard mantienes el 100% de la propiedad del código sin rentas por usuario.',

    // Alcance y Capacidad de Ingeniería (Doctrina Vanguard)
    'qual.badge': 'Alcance & Capacidad de Ingeniería',
    'qual.title': 'De proyectos esenciales elevados al máximo nivel, hasta sistemas complejos hechos simples y funcionales.',
    'qual.desc': 'No importa el punto de partida: aplicamos el mismo rigor arquitectónico para transformar una idea básica en un activo digital de alto rendimiento, o simplificar la operación más compleja en una plataforma intuitiva y fluida.',
    'qual.card1_title': 'De lo elemental a un estándar prémium',
    'qual.card1_desc': 'Si tu proyecto comienza con una necesidad sencilla —un sitio corporativo, un catálogo interactivo o una landing de captación— lo elevamos con código limpio, diseño editorial exclusivo, carga ultrarrápida y arquitectura lista para escalar.',
    'qual.card2_title': 'Sistemas complejos hechos claros y funcionales',
    'qual.card2_desc': 'Si tu empresa maneja múltiples flujos operativos, cotizaciones multinivel, roles de usuario o inventarios sincronizados, desarmamos el caos. Convertimos procesos intrincados en un software intuitivo que tu equipo domina desde el primer día.',
    'qual.card3_title': 'Garantía de ejecución en Semana 2',
    'qual.card3_desc': 'Tanto en soluciones compactas como en ecosistemas empresariales masivos, validamos todo con un prototipo real navegable en la Semana 2. Código 100% de tu empresa, sin rentas mensuales y con soporte directo de ingenieros.',

    // Section 6: Resultados Reales
    'sec6.eyebrow': 'Resultados Reales',
    'sec6.title': 'Lo que cambia en la operación cuando el software responde a tu lógica de negocio.',
    'sec6.desc': 'Directores que recuperaron el control de su operación. Equipos que dejaron de depender de hojas de cálculo. Empresas que crecieron sin contratar más personal administrativo.',

    'sec6.metric1_val': '-70%',
    'sec6.metric1_label': 'Reducción de carga<br>operativa manual',
    'sec6.metric2_val': '3.4×',
    'sec6.metric2_label': 'Multiplicador de<br>conversión comercial',
    'sec6.metric3_val': 'Semana 2',
    'sec6.metric3_label': 'Prototipo navegable\u003cbr\u003ey funcional entregado',
    'sec6.metric4_val': '100%',
    'sec6.metric4_label': 'Propiedad del código<br>desde el primer día',

    'sec6.quote1': 'Antes perdíamos 3 horas diarias persiguiendo aprobaciones internas. Ahora el sistema las gestiona solo y mi equipo comercial se dedica a cerrar, no a administrar.',
    'sec6.role1': 'Director General',
    'sec6.company1': 'Empresa de Servicios B2B · 48 colaboradores',
    'sec6.impact1': '+$120K anuales',

    'sec6.quote2': 'Nuestros clientes llegan al portal, piden cotización y reciben respuesta en minutos. Antes tardábamos dos días. Cerramos tres veces más negocios con el mismo equipo.',
    'sec6.role2': 'Director Comercial',
    'sec6.company2': 'Distribuidora Regional · Logística',
    'sec6.impact2': '3× más cierres',

    'sec6.quote3': 'Lo que más valoré fue ver el prototipo funcionando en la segunda semana. No fue una promesa: era mi negocio real, operando. Desde ahí, confié en el proceso.',
    'sec6.role3': 'Gerente de Operaciones',
    'sec6.company3': 'Clínica Especializada · Citas y Cobro',
    'sec6.impact3': '-65% carga admin',

    'sec6.mid_badge': 'Validación Garantizada',
    'sec6.mid_title': '¿Listo para multiplicar tus conversiones sin añadir más personal?',
    'sec6.mid_desc': 'Sin compromisos forzados ni desembolsos a ciegas. Prototipo funcional navegable en Semana 2: si no supera tus criterios de arquitectura y diseño, cancelas sin penalizaciones ni letras pequeñas.',
    'sec6.mid_cta_btn': 'Comenzar mi proyecto',
    'sec6.mid_wa_btn': 'Chatear por WhatsApp',
    'sec6.mid_wa_msg': 'Hola equipo Vanguard, estoy viendo los casos de éxito y quiero evaluar un proyecto para mi empresa.',

    // Section 7: Siguiente Paso & Formulario
    'sec7.eyebrow': 'El Siguiente Paso',
    'sec7.title': 'La primera conversación es con un ingeniero.<br>No con un vendedor.',
    'sec7.desc': '15 minutos. Sin presentaciones. Sin presión. Solo evaluamos si tiene sentido — y si lo tiene, te mostramos cómo quedaría tu sistema.',

    'sec7.step1_title': 'Conversación técnica directa',
    'sec7.step1_desc': '15 minutos con un Arquitecto de Software. Sin vendedores, sin presentaciones. Evaluamos tu modelo de negocio y la viabilidad del sistema.',
    'sec7.step2_title': 'Prototipo en la segunda semana',
    'sec7.step2_desc': 'Construimos y entregamos un prototipo funcional navegable de tu sistema. Real, operativo y basado en tu lógica de negocio.',
    'sec7.step3_title': 'Tu sistema. Tu propiedad.',
    'sec7.step3_desc': 'El código es tuyo desde el primer día. Tu equipo opera con claridad, tu operación escala y tú te enfocas en crecer. Sin rentas ni dependencias.',

    'sec7.final_title': 'Ver cómo quedaría tu sistema',
    'sec7.final_sub': 'Elige la forma más directa de empezar: una conversación por WhatsApp, una llamada con un ingeniero o déjanos el contexto de tu empresa para preparar una propuesta técnica.',

    'sec7.ch1_title': 'WhatsApp Directo',
    'sec7.ch1_sub': 'Chat directo con ingenieros (sin comerciales)',
    'sec7.ch1_badge': 'Respuesta en <15 min',

    'sec7.ch2_title': 'Llamada Telefónica',
    'sec7.ch2_sub': 'Atención con Arquitecto de Software',
    'sec7.ch2_badge': 'Trato Directo B2B',

    'sec7.ch3_title': 'Correo Corporativo',
    'sec7.ch3_badge': 'Sin Formularios',

    'sec7.ch4_title': 'Sesión Diagnóstico',
    'sec7.ch4_sub': '15 min técnico · Sin ventas agresivas',
    'sec7.ch4_badge': 'Agenda Directa',

    'sec7.divider_text': 'O si prefieres, completa la ficha técnica de tu requerimiento',

    // Form fields & labels
    'form.name_label': 'Nombre completo',
    'form.name_ph': 'Ej. Carlos Mendoza',
    'form.email_label': 'Correo corporativo',
    'form.email_ph': 'carlos@tuempresa.com',
    'form.company_label': 'Empresa o nombre de la idea / proyecto',
    'form.company_ph': 'Ej. Logística Alpha / Nueva Fintech',
    'form.phone_label': 'Teléfono / WhatsApp directo',
    'form.phone_ph': '+34 612 345 678 / +1...',
    'form.type_label': '¿Qué tipo de sistema o solución web necesitas?',

    'form.type1': 'Sistema Web a Medida',
    'form.type2': 'Portal de Clientes & Ventas',
    'form.type3': 'Automatización Operativa & CRM',
    'form.type4': 'SaaS / Plataforma Digital',
    'form.type5': 'E-commerce Avanzado',
    'form.type6': 'Modernización Integral',

    'form.details_label': 'Cuéntanos sobre tu idea, empresa y los requerimientos del sistema',
    'form.details_ph': 'Explícanos: ¿A qué se dedica tu empresa? ¿Qué procesos necesitan automatizar? ¿Qué funciones específicas debe tener la plataforma para estar 100% operativa en tu día a día?',

    'form.timeline_label': 'Plazo deseado de entrega',
    'form.timeline_opt1': 'Tiempo Récord (Prioridad Inmediata)',
    'form.timeline_opt2': 'En 2 a 4 semanas (Sprint estándar)',
    'form.timeline_opt3': '1 a 2 meses (Alcance amplio)',
    'form.timeline_opt4': 'Explorando viabilidad técnica',

    'form.budget_label': 'Presupuesto orientativo (opcional)',
    'form.budget_ph': 'Ej. A convenir según propuesta, o escribe tu presupuesto',

    'form.submit_btn': 'Solicitar propuesta',
    'form.submit_another': 'Enviar otro proyecto o actualización',
    'form.processing': 'Procesando requerimientos...',

    'form.trust1': 'Diagnóstico técnico sin costo',
    'form.trust2': 'Prototipo Semana 2 (Garantía de salida)',
    'form.trust3': 'Repositorio Git propio & Sin rentas',
    'form.trust4': 'NDA previo & Facturación B2B deducible',

    // Form confirmation messages (JS dynamic)
    'form.success_title': 'Proyecto recibido en tiempo récord',
    'form.success_msg_p1': 'Muchas gracias, <strong>{name}</strong>. Hemos registrado con éxito las especificaciones para <strong>{company}</strong> (<em>{systemType}</em>).',
    'form.success_msg_p2': 'Nuestro equipo de ingeniería ya está analizando tu modelo operativo para estructurar la arquitectura y entregarte tu <strong>sistema web funcional y operativo</strong> en tiempo récord. Te contactaremos en breve al correo <strong>{email}</strong> o WhatsApp <strong>{phone}</strong>.',
    'form.success_mailto_copy': '¿Deseas enviar también una copia directa desde tu cliente de correo? Haz clic aquí →',

    // Footer
    'footer.company': 'Vanguard Software Studio',
    'footer.tagline': 'Infraestructura digital de alta ingeniería para negocios que escalan.',
    'footer.rights': '© 2025 Vanguard Software Studio.',
    'footer.platform_heading': 'Plataforma',
    'footer.link_system': 'Sistema Integral',
    'footer.link_automation': 'Automatización',
    'footer.link_sales': 'Motor de Ventas',
    'footer.link_security': 'Seguridad & SLA',
    'footer.link_results': 'Resultados',
    'footer.solutions_heading': 'Soluciones',
    'footer.link_bespoke': 'Software Bespoke',
    'footer.link_portals': 'Portales B2B & CRM',
    'footer.link_billing': 'Pasarelas de Cobro',
    'footer.link_sandboxes': 'Sandboxes Cloudflare',
    'footer.ecosystem_heading': 'Ecosistema',
    'footer.link_diagnostic': 'Diagnóstico Técnico 1 a 1 →',
    'footer.link_consultant': 'Consultor IA de Arquitectura',
    'footer.contact_heading': 'Contacto Directo',
    'footer.link_wa': 'WhatsApp Directo',
    'footer.governance_heading': 'Gobernanza',
    'footer.tag_code': '100% Código Propio',
    'footer.tag_no_rent': 'Cero Rentas SaaS',
    'footer.tag_days': 'Entrega Semana 2',
    'footer.tag_uptime': 'SLA 99.9% Uptime',
    'footer.input_placeholder': 'tu@empresa.com',
    'footer.btn_start': 'Iniciar',
    'footer.hint_spec': 'Blueprint de arquitectura y demo funcional en 48 horas',
    'footer.status_text': 'Todos los sistemas operativos en Edge · SLA 99.9%',
    'footer.location_text': 'Caracas · Remote · Global Cloudflare Edge',
    'footer.alt_mountain': 'Fundador Vanguard contemplando la ciudad al atardecer',

    // Floating WA Tooltip
    'floating.wa_tooltip': '¿Conversamos sobre tu sistema? Responde un ingeniero en <15 min'
  },

  en: {
    // Meta / SEO (High-CTR Commercial Positioning)
    'meta.title': 'Vanguard — Custom Software Development & Business Automation Studio',
    'meta.desc': 'We engineer high-performance custom web systems and automated backoffices for scaling enterprises. Working prototype by Week 2. Request your free diagnostic.',
    'meta.og_title': 'Vanguard — Custom Software Engineering & Process Automation',
    'meta.og_desc': 'Enterprise digital infrastructure and operational automation. Delivered as a working prototype by Week 2 with 100% code ownership. Partner with us today.',

    // Navigation (Desktop & Mobile)
    'nav.system': 'System',
    'nav.results': 'Results',
    'nav.governance': 'Governance',
    'nav.contact': 'Contact',
    'nav.open_menu': 'Open navigation menu',
    'nav.close_menu': 'Close menu',
    'nav.eyebrow': 'Navigation',
    'nav.home': 'Home',
    'nav.digital_system': 'Digital System',
    'nav.start_project': 'Start Project',
    'nav.status_available': 'Available for new projects',
    'nav.wa_direct': 'Direct WhatsApp',

    // Hero Section
    'hero.eyebrow': 'Custom Web Engineering & Enterprise Portals',
    'hero.title': 'Custom web systems that streamline your operations and multiply your sales.',
    'hero.desc': 'We engineer your company\'s core software: connecting your sales front with your internal workflows in a fast, bespoke platform that is 100% yours with zero monthly rents.',
    'hero.cta': 'Design my system',
    'hero.microcopy': 'Live clickable prototype in Week 2 · Zero risk',
    'hero.carousel_prev': 'Previous project',
    'hero.carousel_next': 'Next project',

    // Perspective Carousel Cards
    'card1.tag': 'SaaS Core',
    'card1.name': 'Operations Management',
    'card1.desc': 'Centralized command',
    'card1.alt': 'Core SaaS Architecture — Dashboard and Analytics',

    'card2.tag': 'Fintech',
    'card2.name': 'Banking & Finance',
    'card2.desc': 'Real-time payments',
    'card2.alt': 'Mobile Financial Ecosystem',

    'card3.tag': 'Logistics',
    'card3.name': 'Logistics Portal',
    'card3.desc': 'Fleet traceability',
    'card3.alt': 'Cloud Logistics Portal on Tablet',

    'card4.tag': 'Hospitality',
    'card4.name': 'Smart Dining Tech',
    'card4.desc': 'Orders & reservations',
    'card4.alt': 'Smart Hospitality & Food Tech',

    'card5.tag': 'HealthTech',
    'card5.name': 'Clinical Portal',
    'card5.desc': 'Digital health records',
    'card5.alt': 'Medical System on Tablet',

    'card6.tag': 'Healthcare',
    'card6.name': 'Dental Scheduling',
    'card6.desc': 'Automated booking',
    'card6.alt': 'Mobile Dental Scheduling App',

    'card7.tag': 'Enterprise',
    'card7.name': 'Enterprise ERP Suite',
    'card7.desc': 'Finance & operations',
    'card7.alt': 'Enterprise Cloud Portal',

    'card8.tag': 'Automation',
    'card8.name': 'Data Workflows',
    'card8.desc': '24/7 synchronization',
    'card8.alt': 'Automated Operations Platform',

    // Section 2: Sistema Digital Integral
    'sec2.eyebrow': 'Operational Architecture',
    'sec2.title': 'A single bespoke digital system: synchronizing your sales engine with your internal operations.',
    'sec2.desc': 'Your business should not depend on a dozen disconnected tools, fragile spreadsheets, and communication delays. Vanguard unifies your commercial acquisition and operational dispatch in a 100% proprietary system with zero software rent.',

    'sec2.card1_title': 'Unified Operations',
    'sec2.card1_desc': 'Centralize sales, fulfillment, and customer support into a single operational core, eliminating duplicate data entry and inter-department delays.',

    'sec2.card2_title': '24/7 Client Acquisition',
    'sec2.card2_desc': 'Your business keeps selling and capturing qualified leads while you sleep. The portal automatically vets prospects and triggers internal workflows.',

    'sec2.card3_title': 'Process Automation',
    'sec2.card3_desc': 'Eliminate needless operational drag from day one. Every task currently done manually becomes a streamlined workflow your system executes autonomously.',

    'sec2.wf1_title': 'High-converting commercial portal',
    'sec2.wf1_sub': 'Attracts, qualifies, and closes clients without manual team intervention',
    'sec2.wf2_title': 'Synchronized operations backoffice',
    'sec2.wf2_sub': 'Dispatch, invoice, and fulfill orders without fragile spreadsheets',
    'sec2.wf3_title': 'Real-time executive analytics',
    'sec2.wf3_sub': 'Make decisions backed by clean data, not gut assumptions',
    'sec2.wf4_title': '100% your code, zero user rents',
    'sec2.wf4_sub': 'Total software ownership and IP rights from day one',

    'sec2.mockup_status': 'Vanguard Ecosystem · Live',
    'sec2.mockup_portal': 'Commercial Portal',
    'sec2.mockup_live': 'Live',
    'sec2.mockup_backoffice': 'Backoffice',
    'sec2.mockup_synced': 'Synced',
    'sec2.flow_step1': 'Lead enters',
    'sec2.flow_step2': 'System qualifies',
    'sec2.flow_step3': 'Team acts',
    'sec2.flow_step4': 'Deal closed',

    // Section 3: Automatización
    'sec3.eyebrow': 'Intelligent Automation',
    'sec3.title': 'Stop losing revenue to repetitive tasks: smart automation built for your entire organization.',
    'sec3.desc': 'Every hour your team spends copy-pasting records, chasing internal sign-offs, or updating spreadsheets is revenue lost without value. That ends here.',

    'sec3.before_badge': 'Before',
    'sec3.before_title': 'Manual Chaos',
    'sec3.ba1_bad': 'Quotes sent via back-and-forth emails, taking days to reply',
    'sec3.ba2_bad': 'Customer records scattered across 3 mismatched spreadsheets',
    'sec3.ba3_bad': 'Invoices prepared by hand, prone to frequent human error',
    'sec3.ba4_bad': 'Your leadership stuck putting out operational fires all day',
    'sec3.ba5_bad': 'Sales reports manually consolidated at the end of each week',

    'sec3.after_badge': 'Now',
    'sec3.after_title': '1 Click. Fully Automated.',
    'sec3.ba1_good': 'Portal qualifies and replies to prospects in seconds, 24/7',
    'sec3.ba2_good': 'Unified customer records accessible in one central dashboard',
    'sec3.ba3_good': 'Invoices generated and dispatched automatically upon deal closing',
    'sec3.ba4_good': 'Leadership dedicated to high-level strategy, not admin chores',
    'sec3.ba5_good': 'Executive dashboard updated in real-time, always decision-ready',

    'sec3.pillar1_title': 'Zero Operational Downtime',
    'sec3.pillar1_desc': 'Modernize workflows without interrupting ongoing revenue. Your team keeps delivering while the new architecture deploys in parallel.',
    'sec3.pillar2_title': 'Precision & Zero Defects',
    'sec3.pillar2_desc': 'Eliminate human error and accelerate product delivery. Fewer revision rounds. Faster turnaround times.',
    'sec3.pillar3_title': 'Strategic Leadership Focus',
    'sec3.pillar3_desc': 'Free your leadership to focus on expansion instead of operational bottlenecks. The platform has your back 24/7.',

    'sec3.mid_badge': 'Immediate ROI',
    'sec3.mid_title': 'Does your team lose more than 5 hours every week to manual tasks?',
    'sec3.mid_desc': 'Let’s run a 15-minute technical diagnostic. We pinpoint exactly which processes to automate first so you recover your investment in month one.',
    'sec3.mid_cta_btn': 'Request Free Diagnostic',
    'sec3.mid_wa_btn': 'Chat on WhatsApp',
    'sec3.mid_wa_msg': 'Hello Vanguard team, I would like to consult regarding process automation for my company.',

    // Section 4: Motor de Ventas
    'sec4.eyebrow': 'Revenue Engine',
    'sec4.title': 'Turn traffic into recurring clients and build unbreakable confidence in your brand.',
    'sec4.desc': 'A business responding within seconds closes deals at twice the rate of one replying in days. Your custom portal operates as your highest-performing sales rep — always active, never on leave, and zero mistakes.',

    'sec4.funnel_header': 'Conversion Funnel · Live',
    'sec4.funnel_step1': 'Portal visits',
    'sec4.funnel_step2': 'Qualified interactions',
    'sec4.funnel_step3': 'Inquiries received',
    'sec4.funnel_step4': 'Proposals accepted',
    'sec4.funnel_step5': 'Deals closed',
    'sec4.funnel_rate': 'Conversion rate: <strong>22.0%</strong>',
    'sec4.funnel_vs': 'vs. industry: 3–5%',

    'sec4.benefit1_title': 'The Speed Advantage',
    'sec4.benefit1_desc': 'Respond faster, close contracts with lower friction, and deliver an exceptional customer experience. Every hour of delay is a lost opportunity.',
    'sec4.benefit2_title': 'Know Your Customer',
    'sec4.benefit2_desc': 'Transform data into actionable intelligence to maximize lifetime value. The system learns each prospect’s unique intent.',
    'sec4.benefit3_title': 'Sustained Expansion',
    'sec4.benefit3_desc': 'Scale gross revenue via an optimized digital funnel that handles volume surges smoothly without dropping inquiries or degrading UX.',

    // Section 5: Infraestructura y Seguridad
    'sec5.eyebrow': 'Resilient Infrastructure',
    'sec5.title': 'Scale your business with the absolute confidence of an enterprise-grade backbone.',
    'sec5.desc': 'During traffic peaks and high transaction volumes, infrastructure stability defines your brand equity. Our cloud architecture absorbs sudden surges with zero downtime and guaranteed high availability.',

    'sec5.block1_title': 'Resilient Cloud Architecture',
    'sec5.block1_desc': 'Rock-solid engineering so you scale without fear of system crashes at peak sales periods. Built for intense demand, not just quiet days.',
    'sec5.block1_tag': 'High Availability',

    'sec5.block2_title': 'Complete Security',
    'sec5.block2_desc': 'Your business data and client records shielded under modern enterprise encryption standards. Role-based access controls and full auditability.',
    'sec5.block2_tag': 'Enterprise Compliance',

    'sec5.block3_title': 'Guaranteed Delivery',
    'sec5.block3_desc': 'Flawless execution today to secure your future. A functional production prototype delivered by Week 2, de-risking your investment completely.',
    'sec5.block3_tag': 'Week 2 Guarantee',

    'sec5.guarantee_title': 'Real Working Prototype by Week 2',
    'sec5.guarantee_desc': 'Hands-on functional validation before committing full capital. If the prototype does not exceed your design and performance expectations, you walk away. Zero cost, no questions asked.',
    'sec5.pricing_callout': 'Compare this with legacy agencies billing upfront retainer months for static marketing sites that never generate qualified pipeline. With Vanguard, you retain 100% software ownership with zero monthly per-user licensing fees.',

    // Engineering Scope & Capabilities (Vanguard Doctrine)
    'qual.badge': 'Engineering Scope & Versatility',
    'qual.title': 'From essential projects elevated to premium standards, to complex systems made simple and functional.',
    'qual.desc': 'Whatever your starting point: we apply the same architectural rigor to elevate a straightforward requirement into a high-performance digital asset, or streamline the most intricate enterprise workflows into an intuitive, seamless platform.',
    'qual.card1_title': 'From essential foundations to premium standards',
    'qual.card1_desc': 'If your project begins with a focused requirement — a corporate site, interactive product catalogue, or high-conversion landing page — we elevate it with clean code, bespoke editorial design, instant load speeds, and scale-ready architecture.',
    'qual.card2_title': 'Complex enterprise systems made simple & intuitive',
    'qual.card2_desc': 'If your organization manages multi-tier workflows, complex pricing engines, granular user permissions, or live inventories, we untangle the chaos. We transform intricate processes into software your team masters from day one.',
    'qual.card3_title': 'Week 2 Delivery & Execution Guarantee',
    'qual.card3_desc': 'Whether for focused solutions or large-scale enterprise suites, we validate everything with a real clickable prototype in Week 2. 100% proprietary code owned by your company, zero monthly SaaS rents, and direct engineer access.',

    // Section 6: Resultados Reales
    'sec6.eyebrow': 'Proven Impact',
    'sec6.title': 'Audited operational and commercial metrics from live systems.',
    'sec6.desc': 'The numbers speak for themselves. Executives who regained operational control. Teams that stopped putting out fires. Companies scaling revenue without adding overhead headcount.',

    'sec6.metric1_val': '-70%',
    'sec6.metric1_label': 'Reduction in manual<br>operational workload',
    'sec6.metric2_val': '3.4×',
    'sec6.metric2_label': 'Commercial conversion<br>multiplier',
    'sec6.metric3_val': 'Week 2',
    'sec6.metric3_label': 'Working prototype<br>in production',
    'sec6.metric4_val': '100%',
    'sec6.metric4_label': 'Full source code ownership<br>from day one',

    'sec6.quote1': 'We used to waste 3 hours every day chasing internal approvals. Now the system handles them autonomously and my sales team spends their time closing deals instead of doing paperwork.',
    'sec6.role1': 'Managing Director',
    'sec6.company1': 'B2B Enterprise Services · 48 employees',
    'sec6.impact1': '+$120K annual gain',

    'sec6.quote2': 'Clients land on our portal, request quotes, and get instant answers in minutes. It used to take two business days. We now close three times as many deals with the exact same team.',
    'sec6.role2': 'Chief Commercial Officer',
    'sec6.company2': 'Regional Freight & Logistics',
    'sec6.impact2': '3× deal closure rate',

    'sec6.quote3': 'What won me over was testing our working prototype in week two. It was not a slide deck: it was my actual business logic functioning. From that moment, I fully trusted the process.',
    'sec6.role3': 'Head of Operations',
    'sec6.company3': 'Specialized Clinical Group · Booking & Billing',
    'sec6.impact3': '-65% admin overhead',

    'sec6.mid_badge': 'Guaranteed Validation',
    'sec6.mid_title': 'Ready to multiply conversions without expanding administrative payroll?',
    'sec6.mid_desc': 'Zero locked commitments, zero blind retainers. Live interactive prototype in Week 2: if it does not exceed your architectural criteria, cancel with no penalties.',
    'sec6.mid_cta_btn': 'Start My Project',
    'sec6.mid_wa_btn': 'Chat on WhatsApp',
    'sec6.mid_wa_msg': 'Hello Vanguard team, I am reviewing your client case studies and want to evaluate a project for my company.',

    // Section 7: Siguiente Paso & Formulario
    'sec7.eyebrow': 'The Next Step',
    'sec7.title': 'Maximize your business potential while eliminating friction.<br>It is time to make the next move.',
    'sec7.desc': 'Getting started is simpler than you think. No lock-in contracts, zero upfront risk, and tangible working software delivered in the second week.',

    'sec7.step1_title': '1-on-1 Technical Session',
    'sec7.step1_desc': '15-minute direct session with a Software Architect (zero sales reps, zero pitch). We review your model, stack and feasibility.',
    'sec7.step2_title': 'System Architecture & Build',
    'sec7.step2_desc': 'We engineer and present a functional prototype of your dual ecosystem. Live in production by Week 2.',
    'sec7.step3_title': 'Scale with Peace of Mind',
    'sec7.step3_desc': 'Your platform runs seamlessly, your team operates with clarity, and you focus on expansion. Zero rents, 100% yours.',

    'sec7.final_title': 'Initiate your project and receive a live, fully operational web system',
    'sec7.final_sub': 'Choose the channel that best suits you: connect instantly with an engineer without friction, or submit your company requirements to receive a comprehensive technical proposal.',

    'sec7.ch1_title': 'Direct WhatsApp',
    'sec7.ch1_sub': 'Direct chat with engineers (no sales reps)',
    'sec7.ch1_badge': 'Reply in <15 min',

    'sec7.ch2_title': 'Phone Consultation',
    'sec7.ch2_sub': 'Direct call with Software Architect',
    'sec7.ch2_badge': 'Direct B2B Line',

    'sec7.ch3_title': 'Corporate Email',
    'sec7.ch3_badge': 'No Forms Needed',

    'sec7.ch4_title': 'Diagnostic Session',
    'sec7.ch4_sub': '15 min technical · No sales pressure',
    'sec7.ch4_badge': 'Direct Booking',

    'sec7.divider_text': 'Or submit your detailed technical project briefing below',

    // Form fields & labels
    'form.name_label': 'Full Name',
    'form.name_ph': 'e.g. Charles Montgomery',
    'form.email_label': 'Work Email',
    'form.email_ph': 'charles@yourcompany.com',
    'form.company_label': 'Company or Project Name',
    'form.company_ph': 'e.g. Alpha Logistics / NextGen Fintech',
    'form.phone_label': 'Direct Phone / WhatsApp',
    'form.phone_ph': '+1 (555) 019-2834 / +44...',
    'form.type_label': 'What kind of web system or platform do you require?',

    'form.type1': 'Custom Web System',
    'form.type2': 'Client & Sales Portal',
    'form.type3': 'Operations Automation & CRM',
    'form.type4': 'SaaS / Digital Platform',
    'form.type5': 'Advanced E-Commerce',
    'form.type6': 'End-to-End Modernization',

    'form.details_label': 'Tell us about your business goals and key system requirements',
    'form.details_ph': 'Tell us: What does your company do? Which manual workflows do you need automated? What specific features must the platform have to be 100% operational in your day-to-day?',

    'form.timeline_label': 'Desired Delivery Timeline',
    'form.timeline_opt1': 'Record Time (Immediate Priority)',
    'form.timeline_opt2': '2 to 4 weeks (Standard sprint)',
    'form.timeline_opt3': '1 to 2 months (Broad enterprise scope)',
    'form.timeline_opt4': 'Exploring technical feasibility',

    'form.budget_label': 'Estimated Budget (Optional)',
    'form.budget_ph': 'e.g. Flexible based on proposal, or write your target budget',

    'form.submit_btn': 'Request proposal',
    'form.submit_another': 'Submit another project or update',
    'form.processing': 'Processing project requirements...',

    'form.trust1': 'Free technical diagnostic',
    'form.trust2': 'Week 2 prototype (Exit guarantee)',
    'form.trust3': 'Own Git repo & Zero rent fees',
    'form.trust4': 'Pre-signed NDA & Tax-deductible B2B invoicing',

    // Form confirmation messages (JS dynamic)
    'form.success_title': 'Project received in record time',
    'form.success_msg_p1': 'Thank you, <strong>{name}</strong>. We have successfully logged the specifications for <strong>{company}</strong> (<em>{systemType}</em>).',
    'form.success_msg_p2': 'Our engineering team is already analyzing your operating model to architect your <strong>live, fully operational web system</strong> in record time. We will reach out shortly at <strong>{email}</strong> or WhatsApp <strong>{phone}</strong>.',
    'form.success_mailto_copy': 'Would you also like to send a direct copy from your email client? Click here →',

    // Footer
    'footer.company': 'Vanguard Software Studio',
    'footer.tagline': 'High-performance digital engineering for businesses that scale.',
    'footer.rights': '© 2025 Vanguard Software Studio.',
    'footer.platform_heading': 'Platform',
    'footer.link_system': 'Unified System',
    'footer.link_automation': 'Automation',
    'footer.link_sales': 'Sales Engine',
    'footer.link_security': 'Security & SLA',
    'footer.link_results': 'Results',
    'footer.solutions_heading': 'Solutions',
    'footer.link_bespoke': 'Bespoke Software',
    'footer.link_portals': 'B2B Portals & CRM',
    'footer.link_billing': 'Payment Gateways',
    'footer.link_sandboxes': 'Cloudflare Sandboxes',
    'footer.ecosystem_heading': 'Ecosystem',
    'footer.link_diagnostic': '1-on-1 Technical Diagnostic →',
    'footer.link_consultant': 'AI Architecture Consultant',
    'footer.contact_heading': 'Direct Contact',
    'footer.link_wa': 'Direct WhatsApp',
    'footer.governance_heading': 'Governance',
    'footer.tag_code': '100% Proprietary Code',
    'footer.tag_no_rent': 'Zero SaaS Rent',
    'footer.tag_days': 'Week 2 Delivery',
    'footer.tag_uptime': 'SLA 99.9% Uptime',
    'footer.input_placeholder': 'you@company.com',
    'footer.btn_start': 'Start',
    'footer.hint_spec': 'Architecture blueprint & functional demo in 48 hours',
    'footer.status_text': 'All edge systems operational · SLA 99.9%',
    'footer.location_text': 'Caracas · Remote · Global Cloudflare Edge',
    'footer.alt_mountain': 'Vanguard founder overlooking the city skyline at dusk',

    // Floating WA Tooltip
    'floating.wa_tooltip': 'Shall we discuss your system? An engineer replies in <15 min'
  }
};

const STORAGE_KEY = 'vanguard_lang';
let currentLanguage = 'es';

/**
 * Get active language
 */
export function getLanguage() {
  return currentLanguage;
}

/**
 * Helper to translate a key with optional dynamic variable replacements
 */
export function t(key, vars = {}) {
  const langDict = translations[currentLanguage] || translations.es;
  let text = langDict[key] || translations.es[key] || key;
  for (const [vKey, vVal] of Object.entries(vars)) {
    text = text.replace(new RegExp(`\\{${vKey}\\}`, 'g'), vVal);
  }
  return text;
}

/**
 * Set and apply language across document
 */
export function setLanguage(lang, persist = true) {
  if (lang !== 'es' && lang !== 'en') {
    lang = 'es';
  }
  currentLanguage = lang;

  if (persist) {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore storage quota / private browsing error
    }
  }

  // 1. Update <html lang="...">
  document.documentElement.lang = lang;

  // 2. Update SEO Title & Meta tags
  document.title = t('meta.title');
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) metaDesc.setAttribute('content', t('meta.desc'));

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute('content', t('meta.og_title'));

  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', t('meta.og_desc'));

  const twTitle = document.querySelector('meta[name="twitter:title"]');
  if (twTitle) twTitle.setAttribute('content', t('meta.og_title'));

  const twDesc = document.querySelector('meta[name="twitter:description"]');
  if (twDesc) twDesc.setAttribute('content', t('meta.og_desc'));

  // 3. Update all elements with data-i18n
  const translatableElements = document.querySelectorAll('[data-i18n]');
  translatableElements.forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (key) {
      el.innerHTML = t(key);
    }
  });

  // 4. Update elements with data-i18n-placeholder
  const placeholderElements = document.querySelectorAll('[data-i18n-placeholder]');
  placeholderElements.forEach(el => {
    const key = el.getAttribute('data-i18n-placeholder');
    if (key) {
      el.setAttribute('placeholder', t(key));
    }
  });

  // 5. Update elements with data-i18n-aria
  const ariaElements = document.querySelectorAll('[data-i18n-aria]');
  ariaElements.forEach(el => {
    const key = el.getAttribute('data-i18n-aria');
    if (key) {
      el.setAttribute('aria-label', t(key));
    }
  });

  // 6. Update elements with data-i18n-alt
  const altElements = document.querySelectorAll('[data-i18n-alt]');
  altElements.forEach(el => {
    const key = el.getAttribute('data-i18n-alt');
    if (key) {
      el.setAttribute('alt', t(key));
    }
  });

  // 7. Update language selector buttons state
  updateSelectorButtons(lang);

  // 8. Update dynamic WhatsApp links message query
  updateWhatsAppLinks(lang);

  // 9. Dispatch custom event for reactive components
  window.dispatchEvent(new CustomEvent('vanguard:langchange', { detail: { lang } }));
}

function updateSelectorButtons(activeLang) {
  const buttons = document.querySelectorAll('.lang-btn');
  buttons.forEach(btn => {
    const langVal = btn.getAttribute('data-lang');
    const isActive = langVal === activeLang;
    btn.classList.toggle('active-lang', isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });
}

function updateWhatsAppLinks(lang) {
  const midWaBtn = document.querySelector('.mid-cta-whatsapp-btn');
  if (midWaBtn) {
    const msg = encodeURIComponent(t('sec3.mid_wa_msg'));
    midWaBtn.href = `https://wa.me/584129585353?text=${msg}`;
  }

  const proofWaBtn = document.querySelector('.mid-cta-proof .mid-cta-whatsapp-btn');
  if (proofWaBtn) {
    const msg = encodeURIComponent(t('sec6.mid_wa_msg'));
    proofWaBtn.href = `https://wa.me/584129585353?text=${msg}`;
  }

  const drawerWaLink = document.querySelector('.drawer-direct-link');
  if (drawerWaLink) {
    const msg = encodeURIComponent(
      lang === 'en'
        ? 'Hello Vanguard team, I would like to consult regarding a web system project.'
        : 'Hola equipo Vanguard, quisiera consultar sobre un proyecto web para mi empresa.'
    );
    drawerWaLink.href = `https://wa.me/584129585353?text=${msg}`;
  }

  const fastWaChannel = document.querySelector('.whatsapp-channel');
  if (fastWaChannel) {
    const msg = encodeURIComponent(
      lang === 'en'
        ? 'Hello Vanguard team, I would like to consult regarding a web system project for my business.'
        : 'Hola equipo Vanguard, quisiera consultar sobre un proyecto web para mi empresa.'
    );
    fastWaChannel.href = `https://wa.me/584129585353?text=${msg}`;
  }

  const calendarChannel = document.querySelector('.calendar-channel');
  if (calendarChannel) {
    const msg = encodeURIComponent(
      lang === 'en'
        ? 'Hello Vanguard team, I would like to schedule the complimentary 15-minute diagnostic session.'
        : 'Hola equipo Vanguard, quisiera agendar la sesión de diagnóstico gratuito de 15 minutos.'
    );
    calendarChannel.href = `https://wa.me/584129585353?text=${msg}`;
  }
}

/**
 * Initialize internationalization system
 */
export function initI18n() {
  // 1. Check URL param ?lang=en / ?lang=es
  const urlParams = new URLSearchParams(window.location.search);
  const paramLang = urlParams.get('lang');

  // 2. Check localStorage
  let savedLang = null;
  try {
    savedLang = localStorage.getItem(STORAGE_KEY);
  } catch {
    // storage disabled
  }

  // 3. Check browser language
  let detectedLang = 'es';
  const browserLocale = navigator.language || navigator.userLanguage || '';
  if (browserLocale.toLowerCase().startsWith('en')) {
    detectedLang = 'en';
  }

  // Precedence: URL param > localStorage > browser detection
  const initialLang = (paramLang === 'en' || paramLang === 'es')
    ? paramLang
    : (savedLang === 'en' || savedLang === 'es')
      ? savedLang
      : detectedLang;

  // Set up click handlers on all language selector buttons
  const langButtons = document.querySelectorAll('.lang-btn');
  langButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetLang = btn.getAttribute('data-lang');
      if (targetLang && targetLang !== currentLanguage) {
        setLanguage(targetLang);
      }
    });
  });

  // Apply initial language
  setLanguage(initialLang, false);
}
